import { gql } from "@apollo/client";

const UploadConfirmMutation = gql`
  mutation updateUploadById(
    $id: BigInt!
    $status: String!
    $count: BigInt
    $size: BigInt
  ) {
    updateUploadById(
      input: {
        uploadPatch: { status: $status, imageCount: $count, zipFileSize: $size }
        id: $id
      }
    ) {
      upload {
        id
      }
    }
  }
`;

const hash = "ca8e8e3c0655e6fbad0fc5c93096d38320aaceb2c2c94fd30e94f002434dc563";
export { UploadConfirmMutation, hash };
